
import Button from '../../../components/base/Button';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* About Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                About StarEdge
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                StarEdge is a leading technology company specializing in mobile app development 
                and web solutions for global markets. We combine cutting-edge technology with 
                deep market insights to create digital products that drive business growth.
              </p>
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="text-center p-6 bg-white rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <i className="ri-trophy-line text-blue-600 text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">30+</h3>
                  <p className="text-gray-600">Million Users</p>
                </div>
                <div className="text-center p-6 bg-white rounded-xl shadow-sm">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <i className="ri-global-line text-purple-600 text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">100+</h3>
                  <p className="text-gray-600">Countries</p>
                </div>
              </div>
              <Button 
                size="lg"
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              >
                <i className="ri-message-line mr-2"></i>
                Let's Talk
              </Button>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/b11e6301a62d9661d6164da7cefe799e.jpg"
                alt="StarEdge Office"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl opacity-20"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl opacity-20"></div>
            </div>
          </div>

          {/* Values Section */}
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-12">Our Values</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-8 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lightbulb-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">Innovation</h4>
                <p className="text-gray-600 leading-relaxed">
                  We stay ahead of technology trends to deliver cutting-edge solutions 
                  that give our clients a competitive advantage.
                </p>
              </div>
              <div className="p-8 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-line text-purple-600 text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">Quality</h4>
                <p className="text-gray-600 leading-relaxed">
                  Every project undergoes rigorous testing and quality assurance 
                  to ensure exceptional performance and user experience.
                </p>
              </div>
              <div className="p-8 bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-team-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-4">Partnership</h4>
                <p className="text-gray-600 leading-relaxed">
                  We build long-term relationships with our clients, becoming 
                  trusted partners in their digital transformation journey.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
